import t from 'react-translate';
import { useCallback, useContext } from 'react';
import useClearUrlParams from 'athena/hooks/use-clear-url-params';
import { MENTOR_REQUESTS_PARAMS } from 'redux/schemas/models/mentor-request';

import { css } from '@emotion/react';
import { white } from 'styles/global_defaults/colors';
import { screenMdMin } from 'styles/global_defaults/media-queries';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { config } from '@config/pendo.config.json';
import { useMentorRequestContext } from './mentor-request-context';
import useDiscardMentorMessage from 'athena/hooks/use-discard-mentor-message';

const BACK_BUTTON_LEFT_OFFSET = 160;

const styles = css`
  color: ${white} !important;
  left: ${BACK_BUTTON_LEFT_OFFSET}px;
  position: absolute;
  z-index: 2;

  @media (max-width: ${screenMdMin}px) {
    position: unset;
    padding-left: ${standardSpacing}px;
  }
`;

const MentorRequestGoBack = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { setShowFindMentorModal, programAlias } = mentoringProgram;
  const removeParams = useClearUrlParams(MENTOR_REQUESTS_PARAMS);
  const { resetForm, canDiscardChanges } = useMentorRequestContext();
  const translationBase = (
    t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL
  );
  const dataQATag = (
    config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal.goBackButton
  );

  const goBack = useCallback(() => {
    resetForm?.();
    setShowFindMentorModal(true);
    removeParams();
  }, [resetForm, setShowFindMentorModal, removeParams]);

  const openDiscardChangesDialog = useDiscardMentorMessage();

  const handleClick = () => {
    if (canDiscardChanges) {
      goBack();
    } else {
      openDiscardChangesDialog(goBack);
    }
  };

  return (
    <ClickableContainer
      css={styles}
      className='d-flex py-4 align-items-center text-large-regular semi-bold'
      onClick={handleClick}
      data-qa={dataQATag}
      aria-label={translationBase.ARIA_LABEL.BACK({
        mentorAlias: programAlias?.mentor?.capitalizedSingularized,
      })}
    >
      <NvIcon icon='back' size='small' className='mr-2' />
      {translationBase.BACK()}
    </ClickableContainer>
  );
};

export default MentorRequestGoBack;
